<div>
    <button *ngIf="search_model.length > 0" (click)="clearSearch()" style="float: left;" class="btn btn-danger">清空</button>
    <input type="text" [(ngModel)]="search_model" (keyup.enter)="check_user(nType)" class="form-control" style="width: 240px" placeholder="請輸入想搜尋的人名後點enter">
    <div *ngIf="search_result_staus && check_user_info.length === 0">無資料</div>

    <button *ngFor="let item of check_user_info; let i = index" (click)="openModal(item)" data-toggle="modal" data-target=".bd-example-modal-xl" class="btn"></button>

    <div id="carouselExampleIndicators{{id}}" class="carousel slide" data-interval="false">
        <ol class="carousel-indicators" *ngFor="let item of grouped_check_user_info; let i = index">
            <li [attr.data-target]="'#carouselExampleIndicators' + id" [attr.data-slide-to]="i" [class.active]="i === 0"></li>
        </ol>
        <div class="carousel-inner"  *ngIf="nType == 0 && openModel == true">
            <div class="carousel-item" [class.active]="i === 0" *ngFor="let item of grouped_check_user_info; let i = index">
                <button (click)="openModal(itemdetail)" data-toggle="modal" data-target=".bd-example-modal-xl" class="btn" *ngFor="let itemdetail of item; let ix = index;" [ngClass]="{'first-item': ix === 0}">
                    <div class="user-card">
                        <img class="rounded-image" [src]="itemdetail.profile_pic" alt="{{itemdetail.name}}">
                        <div class="user-name">{{itemdetail.name}}</div>
                    </div>
                </button>
            </div>
        </div>
        <div class="carousel-inner"  *ngIf="nType == 0 && openModel == false">
            <div class="carousel-item" [class.active]="i === 0" *ngFor="let item of grouped_check_user_info; let i = index">
                <button (click)="openModal(itemdetail)"  class="btn" *ngFor="let itemdetail of item; let ix = index;" [ngClass]="{'first-item': ix === 0}">
                    <div class="user-card">
                        <img class="rounded-image" [src]="itemdetail.profile_pic" alt="{{itemdetail.name}}">
                        <div class="user-name">{{itemdetail.name}}</div>
                    </div>
                </button>
            </div>
        </div>
        <div class="carousel-inner"  *ngIf="nType == 1">
            <div class="carousel-item" [class.active]="i === 0" *ngFor="let item of grouped_check_user_info; let i = index">
                <button (click)="openModal(itemdetail)" class="btn" *ngFor="let itemdetail of item; let ix = index;" [ngClass]="{'first-item': ix === 0}">
                    <div class="user-card">
                        <img class="rounded-image" [src]="itemdetail.profile_pic" alt="{{itemdetail.name}}">
                        <div class="user-name">{{itemdetail.name}}</div>
                    </div>
                </button>
            </div>
        </div>
        <button class="carousel-control-prev" type="button" [attr.data-target]="'#carouselExampleIndicators' + id" data-slide="prev" *ngIf="grouped_check_user_info.length > 0">
            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
            <span class="sr-only">Previous</span>
        </button>
        <button class="carousel-control-next" type="button" [attr.data-target]="'#carouselExampleIndicators' + id" data-slide="next" *ngIf="grouped_check_user_info.length > 0">
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
            <span class="sr-only">Next</span>
        </button>
    </div>
</div>